<template>
    <div>
        <div class="form-horizontal">
            <form-input :form="form" property="name"></form-input>
            <form-input :form="form" property="permissions">
                <json-viewer v-model="form.permissions"></json-viewer>
            </form-input>
        </div>
    </div>
</template>


<script>
import Model from 'lib/Model';
import Form from 'lib/Form';

export default {
    mixins: [Model],
    data() {
        return {
            method: '/api/groups',
            form: new Form(() => {
                return {
                    name: '',
                    permissions: {},
                };
            })
        };
    }
};
</script>



// WEBPACK FOOTER //
// resources/js/forms/Group.vue